/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_CapabilitiesInputs */

const en_directory_knowledge_capabilities = /** @type {(inputs: Directory_Knowledge_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capabilities`)
};

const zh_directory_knowledge_capabilities = /** @type {(inputs: Directory_Knowledge_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心能力`)
};

/**
* | output |
* | --- |
* | "Capabilities" |
*
* @param {Directory_Knowledge_CapabilitiesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_capabilities = /** @type {((inputs?: Directory_Knowledge_CapabilitiesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_CapabilitiesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_capabilities(inputs)
	return zh_directory_knowledge_capabilities(inputs)
});
export { directory_knowledge_capabilities as "directory.knowledge.capabilities" }